// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1YRCf","calendarButtons":"ClockData_calendarButtons__HxxwZ"};